const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  return {
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
    },
    leaveGameMenu: {
      whiteSpace: 'nowrap',
      padding: 0,
      background: 'transparent',
      '& > li': {
        color: theme.textColor,
        borderRadius: '10px',
        '&:not(:last-child)': {
          marginBottom: 5,
        },
      },
      '& .ant-dropdown-menu-item': {
        '&:hover': {backgroundColor: '#55555C'},
        fontSize: '12px',
      },
      '& .ant-dropdown-menu-item-icon': {
        fontSize: '16px',
      },
    },
    leaveGameMenuItem: {
      // backgroundColor: '#AE3f41',
      background:
        'linear-gradient(0deg, rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0.5)), rgba(0, 0, 0, 0.25)',
      extend: 'leaveTableMenuItem',
    },
    leaveTableMenuItem: {
      background:
        ' linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      backdropFilter: 'blur(12.5px)',
      borderRadius: '10px',
    },
    hidden: {
      display: 'none',
    },
    dropdownMask: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      zIndex: 999,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
